"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const FormGroup_1 = __importDefault(require("@mui/material/FormGroup"));
const FormHelperText_1 = __importDefault(require("@mui/material/FormHelperText"));
const react_hook_form_1 = require("react-hook-form");
const InputLabel_1 = __importDefault(require("../InputLabel"));
const styles_1 = require("./styles");
const Select_1 = __importDefault(require("./Select"));
const StyledHelperText = (0, styled_components_1.default)(FormHelperText_1.default) `
  ${styles_1.HelperTextStyles}
`;
const Select = ({ InputLabelProps, label, optional, helperText, control, name = "", ...props }) => {
    const { error, disabled } = props;
    return ((0, jsx_runtime_1.jsxs)(FormGroup_1.default, { children: [label && ((0, jsx_runtime_1.jsx)(InputLabel_1.default, { ...InputLabelProps, label: label, optional: optional })), control ? ((0, jsx_runtime_1.jsx)(react_hook_form_1.Controller, { control: control, name: name, 
                // eslint-disable-next-line @typescript-eslint/no-shadow
                render: ({ field: { name, onBlur, onChange, value } }) => {
                    return ((0, jsx_runtime_1.jsx)(Select_1.default, { ...props, name: name, onBlur: onBlur, onChange: (e) => onChange(e.target.value), value: value }));
                } })) : ((0, jsx_runtime_1.jsx)(Select_1.default, { ...props })), helperText && ((0, jsx_runtime_1.jsx)(StyledHelperText, { disabled: disabled, error: error, children: helperText }))] }));
};
exports.default = Select;
//# sourceMappingURL=index.js.map